import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Import icons
import { ReactComponent as SearchIcon } from 'assets/icons/ic_search.svg';

// Import utilities
import { useAuth } from 'components/utilities';

// Import components
import { Button, LanguageDropdown } from 'components/elements';
import NavDropdown from './NavDropdown';
import { Favourites } from './favourites/Favourites';
import { Reminders } from './reminders/Reminders';

// Import helpers
import { hasSeveralLanguages } from 'helpers/languages';

const NavToolbar = ({ toggle }) => {
	const { isAuth } = useAuth();

	return (
		<NavToolbarStyled>
			<Item>
				<Button modifiers={['navIcon']} onClick={toggle}>
					<SearchIcon />
				</Button>
			</Item>
			{isAuth && (
				<>
					<Item>
						<Favourites />
					</Item>

					<Item>
						<Reminders />
					</Item>
				</>
			)}
			<Item>
				<SolidLine />
			</Item>

			{hasSeveralLanguages && (
				<>
					<Item>
						<LanguageDropdown />
					</Item>
					<Item>
						<SolidLine />
					</Item>
				</>
			)}

			<Item>
				<NavDropdown />
			</Item>
		</NavToolbarStyled>
	);
};

const NavToolbarStyled = styled.ul`
	list-style: none;
	display: flex;
`;

const Item = styled.li`
	display: flex;
	align-items: center;
	color: ${({ theme: { header } }) => header.icon};
`;

const SolidLine = styled.span`
	display: inline-block;
	height: 3rem;
	width: 0.1rem;
	margin: 0 1.5rem;
	background-color: ${({ theme: { header } }) => header.separateLine};
`;

NavToolbar.propTypes = {
	toggle: PropTypes.func.isRequired
};

export default NavToolbar;
